import { useState } from "react";
import { Popover } from "flowbite-react";
import { ShoppingCart } from "lucide-react";
import { CartDropdown } from "@/features/cart/components/CartDropdown";
import RoundedIconButton from "@/shared/components/customButtons/roundedIconButton";
import { useCartCounts } from "@/shared/context/UnifiedCartContext";

export const CartIcon = () => {
  // Le badge reflète le panier unifié — sans `rentalsItemCount` les
  // locations apparaissaient dans le dropdown (CartDropdown agrège
  // les 3 cart-types) mais l'icône restait à 0, ce qui laissait
  // croire que le panier était vide.
  const { boutiqueItemCount, dealsItemCount, rentalsItemCount } = useCartCounts();
  const totalItems = boutiqueItemCount + dealsItemCount + rentalsItemCount;
  const hasItems = totalItems > 0;
  const [isOpen, setIsOpen] = useState(false);

  return (
    <Popover
      aria-labelledby="cart-popover"
      content={<CartDropdown onClose={() => setIsOpen(false)} />}
      trigger="click"
      placement="bottom-end"
      open={isOpen}
      onOpenChange={setIsOpen}
    >
      <div className="relative">
        <RoundedIconButton
          icon={ShoppingCart}
          ariaLabel="Panier"
          className="[&_svg]:!transition-colors [&_svg]:!duration-[600ms] [&_svg]:!ease-in-out"
        />
        {hasItems && (
          <span className="absolute top-0 right-0 flex items-center justify-center min-w-5 h-5 px-1 text-xs font-bold text-white bg-primary rounded-full pointer-events-none">
            {totalItems > 99 ? "99+" : totalItems}
          </span>
        )}
      </div>
    </Popover>
  );
};
